import { z } from "zod";
import { CompositionConfigLight } from "../../../types";
import { UserHighlightCardsV1Props } from "./types";

const UserHighlightCardsV1Config: CompositionConfigLight<UserHighlightCardsV1Props> = {
	name: "UserHighlightCardsV1",
	assertValidProps: (props) => {
		return z
			.object({
				imageUrls: z.array(z.string()).min(1).max(5),
				firstProfilePictureUrl: z.string(),
				secondProfilePictureUrl: z.string(),
				cardText: z.string(),
				footerText: z.string(),
			})
			.parse(props) satisfies UserHighlightCardsV1Props;
	},
	videoConfig: {
		numFrames: 1,
		width: 1080,
		height: 1920,
	},
};

export default UserHighlightCardsV1Config;
